module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block block-themed"
  }, [_c('div', {
    staticClass: "block-header bg-primary-dark"
  }, [_c('h2', {
    staticClass: "block-title",
    staticStyle: {
      "font-size": "18px"
    },
    on: {
      "click": function($event) {
        return _vm.selectThisSubBundle()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-usb fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.subBundleIndex + 1) + ":" + _vm._s(_vm.actualBundle.sub_bundle[_vm.subBundleIndex].ReferenceName))]), _vm._v(" "), (_vm.flagDisplayPowerBar && _vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayEnable) ? _c('div', {
    staticClass: "row"
  }, [_c('hr'), _vm._v(" "), (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayActual) ? _c('div', {
    staticClass: "col-xs-6 col-sm-4 col-md-3 col-lg-2"
  }, [(_vm.flagDisplayPowerMA) ? _c('relative-power-bar', {
    attrs: {
      "barData": _vm.powerBarData5Min
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA001H) ? _c('div', {
    staticClass: "col-xs-6 col-sm-4 col-md-3 col-lg-2"
  }, [(_vm.flagDisplayPowerMA) ? _c('relative-power-bar', {
    attrs: {
      "barData": _vm.powerBarDataMA_001H
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA004H) ? _c('div', {
    staticClass: "col-xs-6 col-sm-4 col-md-3 col-lg-2"
  }, [(_vm.flagDisplayPowerMA) ? _c('relative-power-bar', {
    attrs: {
      "barData": _vm.powerBarDataMA_004H
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA006H) ? _c('div', {
    staticClass: "col-xs-6 col-sm-4 col-md-3 col-lg-2"
  }, [(_vm.flagDisplayPowerMA) ? _c('relative-power-bar', {
    attrs: {
      "barData": _vm.powerBarDataMA_006H
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA012H) ? _c('div', {
    staticClass: "col-xs-6 col-sm-4 col-md-3 col-lg-2"
  }, [(_vm.flagDisplayPowerMA) ? _c('relative-power-bar', {
    attrs: {
      "barData": _vm.powerBarDataMA_012H
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA024H) ? _c('div', {
    staticClass: "col-xs-6 col-sm-4 col-md-3 col-lg-2"
  }, [(_vm.flagDisplayPowerMA) ? _c('relative-power-bar', {
    attrs: {
      "barData": _vm.powerBarDataMA_024H
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA072H) ? _c('div', {
    staticClass: "col-xs-6 col-sm-4 col-md-3 col-lg-2"
  }, [(_vm.flagDisplayPowerMA) ? _c('relative-power-bar', {
    attrs: {
      "barData": _vm.powerBarDataMA_072H
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA168H) ? _c('div', {
    staticClass: "col-xs-6 col-sm-4 col-md-3 col-lg-2"
  }, [(_vm.flagDisplayPowerMA) ? _c('relative-power-bar', {
    attrs: {
      "barData": _vm.powerBarDataMA_168H
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA336H) ? _c('div', {
    staticClass: "col-xs-6 col-sm-4 col-md-3 col-lg-2"
  }, [(_vm.flagDisplayPowerMA) ? _c('relative-power-bar', {
    attrs: {
      "barData": _vm.powerBarDataMA_336H
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.actualBundle.bundle_configuration.channelDisplayOptions.movingAverageOptions.flagDisplayMA720H) ? _c('div', {
    staticClass: "col-xs-6 col-sm-4 col-md-3 col-lg-2"
  }, [(_vm.flagDisplayPowerMA) ? _c('relative-power-bar', {
    attrs: {
      "barData": _vm.powerBarDataMA_720H
    }
  }) : _vm._e()], 1) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.actualBundle.bundle_configuration.channelDisplayOptions.attributesDisplayFlag) ? _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.actualBundle.sub_bundle[_vm.subBundleIndex].Attributes), function(attribute, index) {
    return _c('div', [(_vm.actualBundle.sub_bundle[_vm.subBundleIndex].Attributes[index] != 'ND') ? _c('div', {
      staticClass: "col-xm-6 col-sm-4 col-md-2"
    }, [_c('button', {
      staticClass: "btn btn-xs btn-default",
      attrs: {
        "type": "button"
      }
    }, [_vm._v(_vm._s(_vm.actualBundle.sub_bundle[_vm.subBundleIndex].Attributes[index]))])]) : _vm._e()])
  }), 0)]) : _vm._e()])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-66b24256","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/measurements/DisplaySubBundle.vue
// module id = 1545
// module chunks = 4